import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { DataClassificationEnabledQuery } from '../queries/DataClassificationEnabled.graphql';
import type { DataClassificationEnabledQuery as DataClassificationEnabledQueryType } from '../queries/__types__/DataClassificationEnabledQuery';

export function preloadDataClassificationEnabled() {
	return query<DataClassificationEnabledQueryType, null>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: DataClassificationEnabledQuery,
	});
}
